
export default function TrustElementsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">
                Why Choose Our Consultation Services?
              </h2>
              <p className="text-xl text-gray-600 mb-8">
                We've helped over 500 entrepreneurs successfully obtain their Georgia dealer license. Here's what makes our consultation services different:
              </p>

              <div className="space-y-6">
                {/* Step-by-Step Guidance */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Personal Consultation Sessions</h3>
                    <p className="text-gray-600">
                      One-on-one guidance sessions that eliminate confusion and provide personalized support for your specific situation
                    </p>
                  </div>
                </div>

                {/* Downloadable Resources */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-download-line text-xl text-blue-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Complete Course Included</h3>
                    <p className="text-gray-600">
                      Full 8-module course with templates, checklists, and forms you can use immediately to streamline your application
                    </p>
                  </div>
                </div>

                {/* Expert Support */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-voice-line text-xl text-purple-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Expert Support</h3>
                    <p className="text-gray-600">
                      Direct access to licensing experts who have real dealership experience and know the process inside out
                    </p>
                  </div>
                </div>

                {/* Completion Certificate */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-award-line text-xl text-yellow-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Completion Certificate</h3>
                    <p className="text-gray-600">
                      Official certificate of completion you can share on LinkedIn and with potential partners
                    </p>
                  </div>
                </div>

                {/* Save Time & Money */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-time-line text-xl text-red-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Save Time & Money</h3>
                    <p className="text-gray-600">
                      Avoid costly mistakes and delays that can set you back months in the licensing process
                    </p>
                  </div>
                </div>

                {/* Mobile-Friendly Learning */}
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-smartphone-line text-xl text-indigo-600"></i>
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 mb-2">Lifetime Access</h3>
                    <p className="text-gray-600">
                      Access your course content anywhere, anytime on any device with lifetime access to all updates
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Image */}
            <div className="relative">
              <img 
                src="https://public.readdy.ai/ai/img_res/9277b4ccb3f1b632d14e55381ad18ab0.jpg"
                alt="Professional Consultation Services" 
                className="rounded-2xl shadow-2xl object-cover w-full h-96"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-lg">
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                    <i className="ri-trophy-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">95% Success Rate</div>
                    <div className="text-sm text-gray-600">Clients get licensed</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}